import BodyPassword from "../../account/BodyPassword";
import Footer from "../../shared/Footer";
import HeaderBar from "../HeaderBar/HeaderBar";

const ResetPassword = () => {
  return (
    <div className="ResetPassword">
      {/* <NavTagline /> */}
      <HeaderBar />
      <section className="layout-container">
        <div className="container">
          <div className="descript-container">
            <div className="form-title g-clr">Reset Password</div>
            Here is your request to reset your password. Contact SES support at{" "}
            <a href="mailto:support@secureexsolutions.com">
              support@securexsolutions.com
            </a>{" "}
            or 1-888-470-9913 ext.2 if you need assistance.
          </div>
          <BodyPassword />
        </div>
      </section>
      <Footer />
    </div>
  );
};

ResetPassword.defaultProps = {};

export default ResetPassword;